<template>
  <div class="sec1">
    <van-tabbar route>
      <van-tabbar-item
          to="/home"
      >
<!--        <span>首页</span>-->
        <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? home.active : home.default"
        >
      </van-tabbar-item>

      <div class="van-tabbar-item">
        <van-tabbar-item
          to="/document"
        >
  <!--        <span>资讯</span>-->
          <img
              slot="icon"
              slot-scope="props"
              :src="props.active ? document.active : document.default"
          >
        </van-tabbar-item>
      </div>
<!--      <van-tabbar-item-->
<!--          to="/document"-->
<!--      >-->
<!--        &lt;!&ndash;        <span>资讯</span>&ndash;&gt;-->
<!--        <img-->
<!--            slot="icon"-->
<!--            slot-scope="props"-->
<!--            :src="props.active ? document.active : document.default"-->
<!--        >-->
<!--      </van-tabbar-item>-->
       <van-tabbar-item
          to="/TransactionRecord"
      >
<!--        <span>资产</span>-->
        <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? TransactionRecord.active : TransactionRecord.default"
        >
      </van-tabbar-item>
      <van-tabbar-item
          to="/Twitter"
      >
        <!--        <span>资产</span>-->
        <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? community.active : community.default"
        >
      </van-tabbar-item>

      <van-tabbar-item
          to="/TrusteeshipDetails"
      >
        <!--        <span>资讯</span>-->
        <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? Chuantong.active : Chuantong.default"
        >
      </van-tabbar-item>
<!--      <van-tabbar-item-->
<!--          to="/my"-->
<!--      >-->
<!--&lt;!&ndash;        <span>我的</span>&ndash;&gt;-->
<!--        <img-->
<!--            slot="icon"-->
<!--            slot-scope="props"-->
<!--            :src="props.active ? my.active : my.default"-->
<!--        >-->
<!--      </van-tabbar-item>-->

    </van-tabbar>
  </div>

</template>

<script>
  import {Toast} from '../tools/index';
  import Home from "../assets/img/Home.png";
  import HomeDefault from "../assets/img/HomeDefault.png";
  import Document from "../assets/img/Document .png";
  import DocumentDefault from "../assets/img/DocumentDefault.png";
  import Copy from "../assets/img/Copy.png";
  import CopyDefault from "../assets/img/CopyDefault.png";
  import Community from "../assets/img/Community.png"
  import CommunityDefault from "../assets/img/CommunityDefault.png"
  import Profile from "../assets/img/Profile.png";
  import ProfileDefault from "../assets/img/ProfileDefault.png";
  import Chuantong from "../assets/img/Chuantong.png";
  import ChuantongDefault from "../assets/img/ChuantongDefault.png";

  export default {
    name: 'TabBar',
    data() {
      return {
        home: {
          active: Home,
          default: HomeDefault,
        },
        document: {
          active: Document,
          default: DocumentDefault,
        },
        TransactionRecord: {
          active: Copy,
          default: CopyDefault,
        },
        community: {
          active: Community,
          default: CommunityDefault,
        },
        Chuantong: {
          active: Chuantong,
          default: ChuantongDefault,
        },
        my: {
          active: Profile,
          default: ProfileDefault,
        },
      }
    },
    methods: {
      showWaiting() {
        Toast('暂未开放')
      }
    },
    mounted() {
    }
  }

</script>

<style lang="less" scoped>
  .sec1 {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 10;
    height: 50px;
  }
  .van-tabbar-item__icon img{
    width: 22px;
    height: 21px;
  }
  .van-tabbar-item__text span {
    font-size: 12px;
    color: black;
  }
  .van-tabbar--fixed{
    background-color: #ffffff;

  }
</style>
